// extracted by mini-css-extract-plugin
module.exports = {"button":"SelectColor_button__2LHY1","floating":"SelectColor_floating__4ervZ","colorShowcase":"SelectColor_colorShowcase__8j_QO","withCrossLine":"SelectColor_withCrossLine__12ln6"};